export default __webpack_public_path__ + "static/media/paysuccess.7a968669.svg";